<template>
    <div  class="row" >
      <div class="col-12">
        <div class="froala-headline-editor">
          <!-- Any tag modification will change how froala data is saved. See saveWithHtml method -->
          <InlineEditor
            class="froala-editor"
            :config="config"
            :content="content"
            @change="(value) => selectAction(value)"/>
        </div>
      </div>
    </div>
</template>

<script>
import InlineEditor from "./InlineEditor.vue"

export default {
  name: "TextOptions",
  components: { InlineEditor },
  props: {
    config: {
      type: Object,
      required: true
    },
    content: {
      type: String,
      required: true
    },
  },
  methods: {
    selectAction (value) {
      this.$emit('save', value)
    },
  }
};
</script>

<style scoped>

</style>